import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { FaFileExcel } from 'react-icons/fa';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './trainingMessages';

const TrainingExportButton = props => {
  const {
    intl,
    disabled = false,
    exporting = false,
    onExportAssignments,
    onExportTimeRegistrations,
  } = props;

  return (
    <DropdownButton
      bsSize="xsmall"
      bsStyle="default"
      className="btn-default margin10R"
      id="training-export-button"
      disabled={exporting || disabled}
      pullRight
      title={
        <span>
          <span className="margin5R">
            {exporting ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              <FaFileExcel className="file-icon" />
            )}
          </span>
          <FormattedMessage {...messages.Export} />
        </span>
      }
    >
      <MenuItem onClick={onExportAssignments} id="training-export-assignments">
        {intl.formatMessage(messages.ExportTrainingAssignments)}
      </MenuItem>
      <MenuItem onClick={onExportTimeRegistrations} id="training-export-timeregistrations">
        {intl.formatMessage(messages.ExportTrainingTimeRegistrations)}
      </MenuItem>
    </DropdownButton>
  );
};

TrainingExportButton.propTypes = {
  intl: intlShape.isRequired,
  onExportAssignments: PropTypes.func.isRequired,
  onExportTimeRegistrations: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  exporting: PropTypes.bool,
};

export default injectIntl(TrainingExportButton);
